import React, { useEffect, useRef } from "react";
import "./PopeyeShipmentUpdateElements.scss";
import { Tooltip } from 'antd';
import Track from '../../Track/Track';
import { getIcon, getStateSmallIcon } from "../../../utils/images";
import { ReactSVG } from "react-svg";
import LocationTrackTransit from "../../LocationTrack/LocationTrackTransit/LocationTrackTransit";
import PopeyeUpdatesShipmentMap from "../../ShipmentMap/PopeyeUpdatesShipmentMap";

const PopeyeShipmentUpdateElements = ({shipment}) => {
  const hasData = shipment.pol && shipment.pod && shipment.pol.date && shipment.shipping_line
  const hasLocation = shipment.lng && shipment.lat
  const wrapperRef = useRef(null);
  const transitRef = useRef(null);

  useEffect(() => {
    if (wrapperRef.current && transitRef.current) {
      const wrapperHeight = hasLocation ? 200 : 400;
      wrapperRef.current.style.maxHeight = hasLocation ? `${wrapperHeight}px` : "none";
      wrapperRef.current.style.minHeight = !hasLocation ? `${Math.min(transitHeight, 400)}px` : "none"; // Set the min-height to 400px or the transit height if it's less than 400px
      const transitHeight = transitRef.current.scrollHeight;

      if (transitHeight > wrapperHeight) {
        transitRef.current.style.animation = "marqueeY 30s linear infinite";
      } else {
        transitRef.current.style.animation = "none";
      }
    }
  }, [shipment, hasLocation]);

  return (
    <div className="PopeyeShipmentUpdateElements">
      <div className="Update-Container">
        <div className="ship-number">
          <Tooltip title={shipment.shipping_line?.name}>
            <div className="logo">
              <img src={shipment.shipping_line?.icon || getIcon('logo-mini')} alt="logo" />
            </div>
          </Tooltip>
          <div className="booking-and-shipping-line-name">
            <div className="booking-num">
              {hasData && shipment.client_ref ? (
                <div className="booking-num">
                  <Tooltip title={shipment.client_ref}>
                    {`#${shipment.client_ref}`}
                  </Tooltip>
                </div>
              ) : hasData && shipment.booking_number ? (
                <div className="number">
                  <Tooltip title={shipment.booking_number}>
                    {`#${shipment.booking_number}`}
                  </Tooltip>
                </div>
              ) : hasData && shipment.bl ? (
                <div className="booking-num">
                  <Tooltip title={shipment.bl}>
                    {`#${shipment.bl}`}
                  </Tooltip>
                </div>
              ) : !hasData ? (
                <div className="booking-num">
                  Still Fetching
                </div>
              ) : null}
            </div>
            <div className="shipping-line-name">
              {hasData && (
                <Tooltip title={shipment.shipping_line.name}>
                  {shipment.shipping_line.name}
                </Tooltip>
              )}
              {!hasData && (
                <div >
                  your results will be displayed soon!
                </div>
              )}
              
            </div>
          </div>
        </div>
        {hasData && (
          <div>
            <div className="shipment-route">
              <div className="track-wrapper"><Track shipment={shipment} allowPick={false} allowDrop={false} allowDimmed={false} /></div>
            </div>
            <div className="map-container-update">
              {shipment.delay && (
                <div className="warning-overlay">
                  <img className="logo" src={getStateSmallIcon('attention')} alt="attention Logo" />
                  <p>{`Arrival date is delayed by ${shipment.delay} days`}</p>
                </div>
              )}
              {hasLocation && (
                <PopeyeUpdatesShipmentMap selectedShipment={shipment}/>
              )}
            </div>
            
            <div className="cargo-description">
              <div className="container-cargo">
                <div className="container-logo">
                  <ReactSVG src={getStateSmallIcon('container')} />
                </div>
                <p> Cargo</p>
              </div>
              <div className="cargo-containers-description">
                <Tooltip title='containers-description'>
                  {shipment.cargo}
                </Tooltip>
              </div>
            </div>
            <div className="LocationPaneWrapper" ref={wrapperRef}>
              <div ref={transitRef}>
                <LocationTrackTransit style={{ color: "white" }} shipment={shipment} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PopeyeShipmentUpdateElements;
